module.exports = __webpack_public_path__ + "img/loding2.dea97684.png";